import config from '../../util/config';
import { graphRequest } from '../../util/graphRequest';

export async function vaultRequest(
  query: string,
  variables: {},
): Promise<Response> {
  let url = config.vgs.cname;
  if (!url.includes('https://')) {
    url = `https://${url}`;
  }
  return graphRequest(query, variables, url);
}
